import type emotionMobile from '@emotion/native';
import type emotionWeb from '@emotion/styled';
import type mantineNotifications from '@mantine/notifications';
import type mantineCore from '@mantine/core';
import type tamaguiToast from '@tamagui/toast';
import type tamagui from 'tamagui';

export type EmotionMobileDependency = typeof emotionMobile;
export type SnackbarMobileDependency = typeof tamaguiToast;
export type TamaguiMobileDependency = typeof tamagui;
export type EmotionWebDependency = typeof emotionWeb;
export type SnackbarWebDependency = typeof mantineNotifications;
export type MantineWebDependency = typeof mantineCore;

type WebDeps = {
  emotion: EmotionWebDependency;
  snackbars: SnackbarWebDependency;
  mantine: MantineWebDependency;
};

type MobileDeps = {
  emotion: EmotionMobileDependency;
  snackbars: SnackbarMobileDependency;
  tamagui: TamaguiMobileDependency;
};

let deps:
  | null
  | WebDeps
  | MobileDeps = null;

export function setDeps(
  injectedDeps:
    | WebDeps
    | MobileDeps,
) {
  deps = injectedDeps;
}

export function __expectDeps(): WebDeps | MobileDeps {
  if (deps) {
    return deps;
  }

  throw new Error('__expectDeps, deps not set, call setDeps in _init');
}

export function hasWebDeps() {
  return deps && 'mantine' in deps;
}

export function hasMobileDeps() {
  return deps && 'tamagui' in deps;
}

export function expectWebDeps(): WebDeps {
  if (deps && 'mantine' in deps) {
    return deps;
  }

  throw new Error('expectWebDeps, web deps not set, call setDeps in _init');
}

export function expectMobileDeps(): MobileDeps {
  if (deps && 'tamagui' in deps) {
    return deps;
  }

  throw new Error('expectMobileDeps, mobile deps not set, call setDeps in _init');
}
